import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { cpfMask } from '../services/funcoesAuxiliares';

const Login = () => {
  const [cpf, setCpf] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');
    try {
      await login(cpf, password);
      navigate('/painel');
    } catch (err) {
      setError('O Cpf ou a senha não estão corretos. Por favor, tente novamente.');
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      navigate('/painel');
    }
  }, [user, navigate]);

  return (
    <section className="flex h-screen justify-around items-center bg-[url('https://api.uniscestudantil.org.br/images/bg-padrao.jpg')] bg-no-repeat bg-cover">
      <div className="bg-gray-300 flex justify-between w-[70%] h-1/2">
        <div className="w-1/2 flex flex-col justify-evenly items-center">
          <img
            src="https://api.uniscestudantil.org.br/images/000065-01-l.png"
            alt="logo"
            className="max-w-[300px] max-h-[100px]"
          />
          <h2>Seja Bem Vindo!</h2>
        </div>
        <form className="self-center bg-white flex h-full items-center justify-center w-1/2" onSubmit={handleLogin}>
          <div className="flex m-2.5 p-2.5 flex-col items-start h-full w-full justify-center">
            <h1>Área do usuário</h1>
            <label htmlFor="email-input" className="py-5">
              <input
                className="w-full h-full"
                type="text"
                value={cpf}
                onChange={({ target: { value } }) => setCpf(cpfMask(value))}
                data-testid="login__login_input"
                placeholder="Login"
              />
            </label>
            <label htmlFor="password-input" className="py-5">
              <input
                className="w-full h-full"
                type="password"
                value={password}
                onChange={({ target: { value } }) => setPassword(value)}
                data-testid="login__password_input"
                placeholder="Senha"
              />
            </label>
            {error && (
              <p data-testid="login__input_invalid_login_alert">
                {error}
              </p>
            )}
            <button
              type="submit"
              disabled={loading}
              className="mt-2.5 self-end"
            >
              {loading ? 'Entrando...' : 'Entrar'}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Login;
